<template>
   <div v-if="loading" class="spinner-container">
      <div class="spinner"></div>
    </div>
    <div v-else>
          <!-- Keep-alive should wrap <router-view /> -->
         
    <div class="homepage d-flex flex-column">
         <!-- navbar -->
         <div class="homepage-navbar bg-light shadow mb-auto p-3 bg-primary">
            <div class="d-flex align-items-center">
         
               <span @click="goBack()" class="text-white"><i class="bi bi-arrow-left fs-5"></i></span> &nbsp; &nbsp;
                  
                  <span>
                     <h4 class="text-white">{{language?.add_studnet}}</h4>
                  </span>

                        
                    </div>
         
            
              
            </div>
            



         </div>
    
         <!-- body -->
         <div class="my-auto overflow-auto vh-100">
           
            <!-- Top Evets -->
            <div class="pt-3 bg_card">
                <div class="card-body">

                          <div class="mb-3">
                                    <label for="employee" class="form-label">Search Class</label><br>
                                            <select class="form-select form-select-sm" id="employee" ref="employee" v-model="attendance.classid">
                                                <option v-for="(item, index) in classList" :key="index" :value="item.id">{{ item.name }}</option>
                                </select>
                            </div>

                    </div>
       
            </div>  




                <div class="pt-3 bg_card">
                     <label for="mobile" class="form-label">{{language?.entry_date}}</label>
                     <input type="date"  id="mobile" v-model="attendance.entrydate" class="form-control w-50" required>
                <div class="card-body">

                          <div class="mb-3">
                                    <table class="table">
                                    <thead>
                                        <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Roll no</th>
                                        <th scope="col">Name</th>
                                        <th scope="col">Mark</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in studnetlist" :key="item.id">
                                              <td>{{ index + 1 }}</td>
                                                <td>{{ item.rollno }}</td>
                                                <td>{{ item.name }}</td>
                                                <input type="checkbox" v-model="ids" :value="item.id"   checked>

                                       
                                        </tr>
                                    </tbody>
                                    </table>
                            </div>

                    </div>
       
            </div> 


    <button class="btn btn-primary w-100 save-btn mb-1" @click="saveattendance">Save</button>






         </div>
         
 
      </div>

      
 
</template>
<style>
.save-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  border-radius: 0; /* optional - button ko square rakhne ke liye */
}

</style>
  
<script> 
import axios from "@/plugins/axios";  

export default {
  name: 'Branch',
  components: { 
  },
  mounted() { 
   //  this.fetchWeather();
    this.getBranches(); // Call the method here
    
},
  data() {
    let todayDate = new Date().toISOString().slice(0, 10);
    return { 
      loading:false,
      error:null,
      isUserLogged:false,
      user_details:[],
      language: this.getLocalStorageArray('lang'),
   
      
  

      studnetlist:[], 
      classList:[],
      branch_name:'',


      attendance:{
        classid:'',
        entrydate:todayDate,
     
      
      },
             ids:[],

    }
  },
  methods:{
    initializeHomeContent(){
    

    },
    goBack() {
          
          this.$router.go(-1);
  },
  goprevious() {
          
          this.$router.go("/branch");
  },

 
  
    async getBranches() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("getstudentbyclass").then((response) => {
        
                self.classList=response.data.classList;
               self.language=response.data.language;
               localStorage.setItem('lang',response.data.language);
        
          }).then(() => {
               self.initializeHomeContent();

                
                $("#employee").select2({
                                    width: '350px', 
                                    placeholder:"Search Class Here...",
                                "language": {
                                            "noResults": function(){
                                                return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                            }
                                        },
                                            escapeMarkup: function (markup) {
                                                return markup;
                                            }
                                }).on('change', function (event) {
                                //  alert(event.target.value);
                                   self.attendance.classid=event.target.value; 


                                    self.getstudent(event.target.value);


                                        //self.productsList.slice(0); 
                                    // $('#datatable').DataTable().destroy();                
                                
                                        
                                    // self.calculateTotals();            
                                        
                                    });














          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 





       saveattendance() {
       
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;

           if(self.attendance.classid  == '' ){

         self.$swal.fire("Select Class Name!");

           }else{
            axios.post("saveattendance",{
            ...self.attendance,        // entrydate + other fields
            ids: self.ids // mark array explicitly
            }).then((response) => {

                 

              
                       
                       self.studnetlist=response.data.studnetlist;
                       self.classList=response.data.classList;
                        self.language=response.data.language;

                      self.$router.push('/AttendanceReport');



                     self.$swal.fire(response.data.message);
                     if(response.data.success)
                     {
                        self.branch={ name:'',         address:'',contact:'',};
                     }
                     window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).hide();
                      
                  
               
        
          }).then(() => {
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
         
  }
        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 


      editStudent(editStudent) {
         window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).show();
         this.addstudent=editStudent;
      }, 





      deleteAddStudent(id = "") {
    this.loading = true;
    this.error = null;

    try {
        var self = this;

        this.$swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel",
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post("deleteAddStudent", { id: id }).then((response) => {
                     self.studnetlist=response.data.studnetlist;
                    self.$swal.fire(response.data.message);
                    
                    if (response.data.success) {
                        window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).hide();
                    }
                }).then(() => {
                    self.initializeHomeContent();
                }).catch((err) => {
                    self.$swal.fire("Error!", "Something went wrong.", "error");
                });
            }
        });

    } catch (err) {
        this.error = err.response?.data?.message || "Login failed. Please try again.";
    } finally {
        this.loading = false;
    }
},

        getLocalStorageArray(key) {
                let data = localStorage?.getItem(key);
                try {
                    return data ? JSON.parse(data) : [];
                } catch (e) {
                    console.error("Error parsing localStorage data", e);
                    return [];
                }
            },






              async getstudent(id) {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("getstudentlist",{id:id}).then((response) => {
               self.studnetlist=response.data.studnetlist;
                self.classList=response.data.classList;
               self.language=response.data.language;
               localStorage.setItem('lang',response.data.language);
        
          }).then(() => {
               self.initializeHomeContent();

                
                $("#employee").select2({
                                    width: '350px', 
                                    placeholder:"Search Class Here...",
                                "language": {
                                            "noResults": function(){
                                                return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                            }
                                        },
                                            escapeMarkup: function (markup) {
                                                return markup;
                                            }
                                }).on('change', function (event) {
                                //  alert(event.target.value);
                                   self.addstudent.classid=event.target.value; 


                                    getstudent(event.target.value);


                                        //self.productsList.slice(0); 
                                    // $('#datatable').DataTable().destroy();                
                                
                                        
                                    // self.calculateTotals();            
                                        
                                    });


                                    














          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 




















  }
}






</script>
